<template>
  <!-- Desktop Sidebar - Collapsible -->
  <aside 
    class="hidden lg:flex flex-col bg-casino-sidebar border-r border-white/5 flex-shrink-0 z-[9500] relative transition-all duration-300"
    :class="isOpen ? 'w-64' : 'w-16'"
  >
    <!-- Logo & Toggle Button -->
    <div class="h-14 sm:h-16 flex items-center px-3 border-b border-white/5 bg-casino-sidebar sticky top-0 z-[9600]" :class="isOpen ? 'justify-between' : 'justify-center'">
      <RouterLink to="/" @click="handleNavClick($event, '/')" class="flex items-center gap-3 hover:opacity-80 transition-opacity" :class="!isOpen && 'justify-center'">
        <img src="/todofino_icon.png" alt="TodoFino" class="w-8 h-8 rounded-lg object-cover flex-shrink-0" />
          <img v-if="isOpen" src="/todofino_logo.png" alt="TodoFino.bet" class="h-7" />
      </RouterLink>
      
      <!-- Toggle Button - Only visible when expanded -->
      <button
        v-if="isOpen"
        @click="$emit('toggle')"
        class="p-2 rounded-lg hover:bg-white/10 transition-colors text-gray-400 hover:text-white"
        :title="t('sidebar.collapse')"
      >
        <PanelLeftClose class="w-5 h-5" />
      </button>
    </div>

    <!-- Navigation -->
    <nav class="flex-1 px-2 py-4 space-y-1 overflow-y-auto overflow-x-hidden">
      <!-- Main -->
      <div class="mb-6">
        <RouterLink
          to="/" @click="handleNavClick($event, '/')"
          :class="[
            'flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors',
            $route.path === '/' 
              ? 'bg-casino-primary/20 text-casino-primary-light' 
              : 'text-gray-400 hover:text-white hover:bg-white/5'
          ]"
        >
          <LayoutGrid class="w-5 h-5 flex-shrink-0" />
          <span v-if="isOpen" class="truncate">{{ t('sidebar.home') }}</span>
        </RouterLink>
        
        <RouterLink
          to="/games" @click="handleNavClick($event, '/games')"
          :class="[
            'flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors',
            $route.path.startsWith('/games') || $route.path.startsWith('/game/')
              ? 'bg-casino-primary/20 text-casino-primary-light' 
              : 'text-gray-400 hover:text-white hover:bg-white/5'
          ]"
        >
          <Gamepad2 class="w-5 h-5 flex-shrink-0" />
          <span v-if="isOpen" class="truncate">{{ t('sidebar.allGames') }}</span>
        </RouterLink>

        <RouterLink
          to="/sportsbook" @click="handleNavClick($event, '/sportsbook')"
          :class="[
            'flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors',
            $route.path.startsWith('/sportsbook')
              ? 'bg-casino-primary/20 text-casino-primary-light'
              : 'text-gray-400 hover:text-white hover:bg-white/5'
          ]"
        >
          <Ticket class="w-5 h-5 flex-shrink-0" />
          <span v-if="isOpen" class="truncate">{{ t('sidebar.sportsbook') }}</span>
        </RouterLink>
        
        <RouterLink
          to="/games?category=slot" @click="handleNavClick($event, '/games?category=slot')"
          :class="[
            'flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors',
            $route.query.category === 'slot'
              ? 'bg-casino-primary/20 text-casino-primary-light' 
              : 'text-gray-400 hover:text-white hover:bg-white/5'
          ]"
        >
          <Clover class="w-5 h-5 flex-shrink-0" />
          <span v-if="isOpen" class="truncate">{{ t('sidebar.slots') }}</span>
        </RouterLink>
        
        <RouterLink
          to="/games?category=table" @click="handleNavClick($event, '/games?category=table')"
          :class="[
            'flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors',
            $route.query.category === 'table'
              ? 'bg-casino-primary/20 text-casino-primary-light' 
              : 'text-gray-400 hover:text-white hover:bg-white/5'
          ]"
        >
          <Diamond class="w-5 h-5 flex-shrink-0" />
          <span v-if="isOpen" class="truncate">{{ t('sidebar.tableGames') }}</span>
        </RouterLink>
        
        <RouterLink
          to="/games?category=live" @click="handleNavClick($event, '/games?category=live')"
          :class="[
            'flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors',
            $route.query.category === 'live'
              ? 'bg-casino-primary/20 text-casino-primary-light' 
              : 'text-gray-400 hover:text-white hover:bg-white/5'
          ]"
        >
          <Video class="w-5 h-5 flex-shrink-0" />
          <span v-if="isOpen" class="truncate">{{ t('sidebar.liveCasino') }}</span>
        </RouterLink>
      </div>

      <!-- OCULTO: VIP card mock, datos en localStorage. No conectado a la API.
      <div v-if="isOpen && authStore.isAuthenticated" class="px-2 mb-6">
        <RouterLink
          to="/vip" @click="handleNavClick($event, '/vip')"
          class="block p-3 rounded-xl border border-white/10 bg-white/5 hover:bg-white/10 transition-all"
          :class="{ 'ring-1 ring-casino-primary/50': $route.path === '/vip' }"
        >
          <div class="flex items-center gap-3 mb-2">
            <div 
              class="w-9 h-9 rounded-lg flex items-center justify-center text-lg"
              :style="{ 
                backgroundColor: vipStore.currentLevel.color + '25',
                color: vipStore.currentLevel.color
              }"
            >
              {{ vipStore.currentLevel.icon }}
            </div>
            <div class="flex-1 min-w-0">
              <p class="text-xs text-gray-500">VIP Level</p>
              <p class="font-bold text-sm text-white truncate">
                {{ vipStore.currentLevel.name }}
              </p>
            </div>
          </div>
          <div class="space-y-1">
            <div class="flex items-center justify-between text-[10px]">
              <span class="text-gray-500">{{ vipStore.currentPoints.toLocaleString() }} pts</span>
              <span v-if="vipStore.nextLevel" class="text-gray-500">
                {{ vipStore.nextLevel.minPoints.toLocaleString() }}
              </span>
              <span v-else class="text-casino-gold">MAX</span>
            </div>
            <div class="h-1.5 bg-white/10 rounded-full overflow-hidden">
              <div 
                class="h-full rounded-full transition-all duration-500"
                :style="{ 
                  width: vipStore.progressPercent + '%',
                  backgroundColor: vipStore.currentLevel.color
                }"
              ></div>
            </div>
          </div>
        </RouterLink>
      </div>
      -->

      <!-- Account - Only when authenticated -->
      <div v-if="authStore.isAuthenticated" class="mb-6">
        <p v-if="isOpen" class="px-3 text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">
          {{ t('sidebar.account') }}
        </p>
        
        <RouterLink
          to="/history" @click="handleNavClick($event, '/history')"
          :class="[
            'flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors',
            $route.path === '/history'
              ? 'bg-casino-primary/20 text-casino-primary-light' 
              : 'text-gray-400 hover:text-white hover:bg-white/5'
          ]"
        >
          <History class="w-5 h-5 flex-shrink-0" />
          <span v-if="isOpen" class="truncate">{{ t('sidebar.history') }}</span>
        </RouterLink>

        <RouterLink
          to="/bonuses" @click="handleNavClick($event, '/bonuses')"
          :class="[
            'flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors',
            $route.path === '/bonuses'
              ? 'bg-casino-primary/20 text-casino-primary-light'
              : 'text-gray-400 hover:text-white hover:bg-white/5'
          ]"
        >
          <Gift class="w-5 h-5 flex-shrink-0" />
          <span v-if="isOpen" class="flex-1 truncate">{{ t('sidebar.bonuses') }}</span>
          <span
            v-if="isOpen && bonusStore.claimableCount > 0"
            class="px-1.5 py-0.5 bg-casino-gold/20 text-casino-gold text-[10px] font-medium rounded"
          >
            {{ bonusStore.claimableCount }}
          </span>
        </RouterLink>
        
        <RouterLink
          to="/favorites" @click="handleNavClick($event, '/favorites')"
          :class="[
            'flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors',
            $route.path === '/favorites'
              ? 'bg-casino-primary/20 text-casino-primary-light' 
              : 'text-gray-400 hover:text-white hover:bg-white/5'
          ]"
        >
          <Heart class="w-5 h-5 flex-shrink-0" />
          <span v-if="isOpen" class="flex-1 truncate">{{ t('sidebar.favorites') }}</span>
          <span 
            v-if="isOpen && favoritesStore.favoriteCount > 0"
            class="px-1.5 py-0.5 bg-casino-loss/20 text-casino-loss text-[10px] font-medium rounded"
          >
            {{ favoritesStore.favoriteCount }}
          </span>
        </RouterLink>
        
        <RouterLink
          to="/profile" @click="handleNavClick($event, '/profile')"
          :class="[
            'flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors',
            $route.path === '/profile'
              ? 'bg-casino-primary/20 text-casino-primary-light' 
              : 'text-gray-400 hover:text-white hover:bg-white/5'
          ]"
        >
          <User class="w-5 h-5 flex-shrink-0" />
          <span v-if="isOpen" class="truncate">{{ t('sidebar.profile') }}</span>
        </RouterLink>
      </div>

      <!-- Soporte -->
      <div>
        <p v-if="isOpen" class="px-3 text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">
          {{ t('sidebar.support') }}
        </p>
        
        <!-- OCULTO: Centro de Ayuda y Chat en Vivo no tienen handler, no funcionan.
        <button class="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium text-gray-400 hover:text-white hover:bg-white/5 transition-colors">
          <HelpCircle class="w-5 h-5 flex-shrink-0" />
          <span v-if="isOpen" class="truncate">Centro de Ayuda</span>
        </button>
        
        <button class="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium text-gray-400 hover:text-white hover:bg-white/5 transition-colors">
          <MessageCircle class="w-5 h-5 flex-shrink-0" />
          <span v-if="isOpen" class="truncate">Chat en Vivo</span>
        </button>
        -->

        <RouterLink
          to="/responsible-gaming" @click="handleNavClick($event, '/responsible-gaming')"
          :class="[
            'flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors',
            $route.path === '/responsible-gaming'
              ? 'bg-casino-win/20 text-casino-win' 
              : 'text-gray-400 hover:text-casino-win hover:bg-white/5'
          ]"
        >
          <Shield class="w-5 h-5 flex-shrink-0" />
          <span v-if="isOpen" class="truncate">{{ t('sidebar.responsibleGaming') }}</span>
        </RouterLink>
      </div>
    </nav>

    <!-- Idioma - fuera del <nav> para que el menú no lo recorte el overflow al estar colapsado -->
    <div class="px-2 py-3 border-t border-white/5">
      <LanguageSwitcher :collapsed="!isOpen" compact />
    </div>

    <!-- OCULTO: texto estatico sin verificacion real.
    <div v-if="isOpen" class="p-4 border-t border-white/5">
      <div class="flex items-center gap-2 text-xs text-gray-500">
        <Shield class="w-4 h-4" />
        <span>Licenciado y Regulado</span>
      </div>
    </div>
    -->
  </aside>

  <!-- Mobile Sidebar - Drawer -->
  <Transition
    enter-active-class="transition-transform duration-300 ease-out"
    enter-from-class="-translate-x-full"
    enter-to-class="translate-x-0"
    leave-active-class="transition-transform duration-300 ease-in"
    leave-from-class="translate-x-0"
    leave-to-class="-translate-x-full"
  >
    <aside 
      v-if="isOpen && isMobile"
      class="fixed inset-y-0 left-0 w-[280px] bg-casino-sidebar border-r border-white/5 flex flex-col z-[9500]"
    >
      <!-- Mobile Header with Close Button -->
      <div class="h-14 flex items-center justify-between px-4 border-b border-white/5 bg-casino-sidebar sticky top-0 z-[9600]">
        <RouterLink to="/" @click="handleNavClick($event, '/'); $emit('close')" class="flex items-center gap-3 hover:opacity-80 transition-opacity">
          <img src="/todofino_icon.png" alt="TodoFino" class="w-8 h-8 rounded-lg object-cover flex-shrink-0" />
            <img src="/todofino_logo.png" alt="TodoFino.bet" class="h-7" />
        </RouterLink>
        <button 
          @click="$emit('close')"
          class="p-2 rounded-lg hover:bg-white/10 text-gray-400 hover:text-white transition-colors"
        >
          <X class="w-5 h-5" />
        </button>
      </div>

      <!-- Navigation -->
      <nav class="flex-1 px-3 py-4 space-y-1 overflow-y-auto">
        <!-- Main -->
        <div class="mb-6">
          <RouterLink
            to="/"
            @click="handleNavClick($event, '/'); $emit('close')"
            :class="[
              'flex items-center gap-3 px-3 py-3 rounded-lg text-sm font-medium transition-colors',
              $route.path === '/' 
                ? 'bg-casino-primary/20 text-casino-primary-light' 
                : 'text-gray-400 hover:text-white hover:bg-white/5'
            ]"
          >
            <LayoutGrid class="w-5 h-5" />
            {{ t('sidebar.home') }}
          </RouterLink>
          
          <RouterLink
            to="/games"
            @click="handleNavClick($event, '/games'); $emit('close')"
            :class="[
              'flex items-center gap-3 px-3 py-3 rounded-lg text-sm font-medium transition-colors',
              $route.path.startsWith('/games') || $route.path.startsWith('/game/')
                ? 'bg-casino-primary/20 text-casino-primary-light' 
                : 'text-gray-400 hover:text-white hover:bg-white/5'
            ]"
          >
            <Gamepad2 class="w-5 h-5" />
            {{ t('sidebar.allGames') }}
          </RouterLink>

          <RouterLink
            to="/sportsbook"
            @click="handleNavClick($event, '/sportsbook'); $emit('close')"
            :class="[
              'flex items-center gap-3 px-3 py-3 rounded-lg text-sm font-medium transition-colors',
              $route.path.startsWith('/sportsbook')
                ? 'bg-casino-primary/20 text-casino-primary-light'
                : 'text-gray-400 hover:text-white hover:bg-white/5'
            ]"
          >
            <Ticket class="w-5 h-5" />
            {{ t('sidebar.sportsbook') }}
          </RouterLink>
          
          <RouterLink
            to="/games?category=slot"
            @click="handleNavClick($event, '/games?category=slot'); $emit('close')"
            :class="[
              'flex items-center gap-3 px-3 py-3 rounded-lg text-sm font-medium transition-colors',
              $route.query.category === 'slot'
                ? 'bg-casino-primary/20 text-casino-primary-light' 
                : 'text-gray-400 hover:text-white hover:bg-white/5'
            ]"
          >
            <Clover class="w-5 h-5" />
            {{ t('sidebar.slots') }}
          </RouterLink>
          
          <RouterLink
            to="/games?category=table"
            @click="handleNavClick($event, '/games?category=table'); $emit('close')"
            :class="[
              'flex items-center gap-3 px-3 py-3 rounded-lg text-sm font-medium transition-colors',
              $route.query.category === 'table'
                ? 'bg-casino-primary/20 text-casino-primary-light' 
                : 'text-gray-400 hover:text-white hover:bg-white/5'
            ]"
          >
            <Diamond class="w-5 h-5" />
            {{ t('sidebar.tableGames') }}
          </RouterLink>
          
          <RouterLink
            to="/games?category=live"
            @click="handleNavClick($event, '/games?category=live'); $emit('close')"
            :class="[
              'flex items-center gap-3 px-3 py-3 rounded-lg text-sm font-medium transition-colors',
              $route.query.category === 'live'
                ? 'bg-casino-primary/20 text-casino-primary-light' 
                : 'text-gray-400 hover:text-white hover:bg-white/5'
            ]"
          >
            <Video class="w-5 h-5" />
            {{ t('sidebar.liveCasino') }}
          </RouterLink>
        </div>

        <!-- OCULTO: VIP card mock, datos en localStorage. No conectado a la API.
        <div v-if="authStore.isAuthenticated" class="px-2 mb-6">
          <RouterLink
            to="/vip"
            @click="handleNavClick($event, '/vip'); $emit('close')"
            class="block p-4 rounded-xl border border-white/10 bg-white/5 hover:bg-white/10 transition-all"
            :class="{ 'ring-1 ring-casino-primary/50': $route.path === '/vip' }"
          >
            <div class="flex items-center gap-3 mb-3">
              <div 
                class="w-10 h-10 rounded-lg flex items-center justify-center text-xl"
                :style="{ 
                  backgroundColor: vipStore.currentLevel.color + '25',
                  color: vipStore.currentLevel.color
                }"
              >
                {{ vipStore.currentLevel.icon }}
              </div>
              <div class="flex-1 min-w-0">
              <p class="text-xs text-gray-500">Nivel VIP</p>
                <p class="font-bold text-sm text-white truncate">
                  {{ vipStore.currentLevel.name }}
                </p>
              </div>
            </div>
            <div class="space-y-2">
              <div class="flex items-center justify-between text-xs">
                <span class="text-gray-500">{{ vipStore.currentPoints.toLocaleString() }} pts</span>
                <span v-if="vipStore.nextLevel" class="text-gray-500">
                  {{ vipStore.nextLevel.minPoints.toLocaleString() }}
                </span>
                <span v-else class="text-casino-gold">MAX</span>
              </div>
              <div class="h-2 bg-white/10 rounded-full overflow-hidden">
                <div 
                  class="h-full rounded-full transition-all duration-500"
                  :style="{ 
                    width: vipStore.progressPercent + '%',
                    backgroundColor: vipStore.currentLevel.color
                  }"
                ></div>
              </div>
            </div>
          </RouterLink>
        </div>
        -->

        <!-- Account - Only authenticated -->
        <div v-if="authStore.isAuthenticated" class="mb-6">
          <p class="px-3 text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">
            {{ t('sidebar.account') }}
          </p>
          
          <RouterLink
            to="/history"
            @click="handleNavClick($event, '/history'); $emit('close')"
            :class="[
              'flex items-center gap-3 px-3 py-3 rounded-lg text-sm font-medium transition-colors',
              $route.path === '/history'
                ? 'bg-casino-primary/20 text-casino-primary-light' 
                : 'text-gray-400 hover:text-white hover:bg-white/5'
            ]"
          >
          <History class="w-5 h-5" />
          {{ t('sidebar.history') }}
        </RouterLink>

        <RouterLink
          to="/bonuses"
          @click="handleNavClick($event, '/bonuses'); $emit('close')"
          :class="[
            'flex items-center gap-3 px-3 py-3 rounded-lg text-sm font-medium transition-colors',
            $route.path === '/bonuses'
              ? 'bg-casino-primary/20 text-casino-primary-light'
              : 'text-gray-400 hover:text-white hover:bg-white/5'
          ]"
        >
          <Gift class="w-5 h-5" />
          <span class="flex-1">{{ t('sidebar.bonuses') }}</span>
          <span
            v-if="bonusStore.claimableCount > 0"
            class="px-2 py-0.5 bg-casino-gold/20 text-casino-gold text-xs font-medium rounded"
          >
            {{ bonusStore.claimableCount }}
          </span>
        </RouterLink>
          
        <RouterLink
          to="/favorites"
            @click="handleNavClick($event, '/favorites'); $emit('close')"
            :class="[
              'flex items-center gap-3 px-3 py-3 rounded-lg text-sm font-medium transition-colors',
              $route.path === '/favorites'
                ? 'bg-casino-primary/20 text-casino-primary-light' 
                : 'text-gray-400 hover:text-white hover:bg-white/5'
            ]"
          >
            <Heart class="w-5 h-5" />
            <span class="flex-1">{{ t('sidebar.favorites') }}</span>
            <span 
              v-if="favoritesStore.favoriteCount > 0"
              class="px-2 py-0.5 bg-casino-loss/20 text-casino-loss text-xs font-medium rounded"
            >
              {{ favoritesStore.favoriteCount }}
            </span>
          </RouterLink>
          
          <RouterLink
            to="/profile"
            @click="handleNavClick($event, '/profile'); $emit('close')"
            :class="[
              'flex items-center gap-3 px-3 py-3 rounded-lg text-sm font-medium transition-colors',
              $route.path === '/profile'
                ? 'bg-casino-primary/20 text-casino-primary-light' 
                : 'text-gray-400 hover:text-white hover:bg-white/5'
            ]"
          >
            <User class="w-5 h-5" />
            {{ t('sidebar.profile') }}
          </RouterLink>
        </div>

        <!-- Support -->
        <div>
          <p class="px-3 text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">
            {{ t('sidebar.support') }}
          </p>
          
          <!-- OCULTO: Centro de Ayuda y Chat en Vivo no tienen handler, no funcionan.
          <button class="w-full flex items-center gap-3 px-3 py-3 rounded-lg text-sm font-medium text-gray-400 hover:text-white hover:bg-white/5 transition-colors">
            <HelpCircle class="w-5 h-5" />
            Centro de Ayuda
          </button>
          
          <button class="w-full flex items-center gap-3 px-3 py-3 rounded-lg text-sm font-medium text-gray-400 hover:text-white hover:bg-white/5 transition-colors">
            <MessageCircle class="w-5 h-5" />
            Chat en Vivo
          </button>
          -->

          <RouterLink
            to="/responsible-gaming"
            @click="handleNavClick($event, '/responsible-gaming'); $emit('close')"
            :class="[
              'flex items-center gap-3 px-3 py-3 rounded-lg text-sm font-medium transition-colors',
              $route.path === '/responsible-gaming'
                ? 'bg-casino-win/20 text-casino-win' 
                : 'text-gray-400 hover:text-casino-win hover:bg-white/5'
            ]"
          >
            <Shield class="w-5 h-5" />
            {{ t('sidebar.responsibleGaming') }}
          </RouterLink>
        </div>
      </nav>

      <!-- Idioma -->
      <div class="px-3 py-3 border-t border-white/5">
        <LanguageSwitcher />
      </div>

      <!-- OCULTO: texto estatico sin verificacion real.
      <div class="p-4 border-t border-white/5">
        <div class="flex items-center gap-2 text-xs text-gray-500">
          <Shield class="w-4 h-4" />
          <span>Licenciado y Regulado</span>
        </div>
      </div>
      -->
    </aside>
  </Transition>
</template>

<script setup>
import { RouterLink, useRoute, useRouter } from 'vue-router'
import { ref, inject } from 'vue'
import { useI18n } from 'vue-i18n'
import LanguageSwitcher from '@/components/LanguageSwitcher.vue'
import { useAuthStore } from '@/stores/auth'
import { useBonusStore } from '@/stores/bonus'
import { useFavoritesStore } from '@/stores/favorites'
import { useVIPStore } from '@/stores/vip'
import { 
  LayoutGrid, 
  Gamepad2, 
  Clover, 
  Diamond, 
  Video, 
  Ticket,
  Gift,
  History, 
  Heart, 
  User, 
  HelpCircle, 
  MessageCircle, 
  Shield,
  X,
  PanelLeftClose
} from 'lucide-vue-next'

const props = defineProps({
  isOpen: {
    type: Boolean,
    default: true
  },
  isMobile: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['close', 'toggle'])

const { t } = useI18n()
const route = useRoute()
const router = useRouter()
const authStore = useAuthStore()
const bonusStore = useBonusStore()
const favoritesStore = useFavoritesStore()
const vipStore = useVIPStore()

// FIX BUG 2: When inside the sportsbook, sidebar navigation should use
// BTRenderer.updateOptions({ url }) instead of full router navigation.
// When outside the sportsbook, normal router navigation is used.
const betbyNavigateFn = inject('betbyNavigateFn', ref(null))

const handleNavClick = (e, path) => {
  // FIX BUG 2: When inside the sportsbook and clicking the home ("/") link,
  // use Betby's updateOptions to navigate within the sportsbook frame.
  // For all other links, let the RouterLink handle normal navigation.
  if (route.path === '/sportsbook' && path === '/' && betbyNavigateFn.value) {
    e.preventDefault()
    betbyNavigateFn.value(path)
    if (props.isMobile) {
      emit('close')
    }
  }
}
</script>
